// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-left.double"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.5 7.5L6 12L10.5 16.5M17 7.5L12.5 12L17 16.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronLeftDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-left-double',
    ref,
    icon: element,
  },
));

ChevronLeftDoubleIcon.displayName = 'ChevronLeftDoubleIcon';

export default ChevronLeftDoubleIcon;
